/**
 * Created by 1 on 2017/8/28.
 */
'use strict';
define([
    './AnalysisFile'
], function(
    AnalysisFile
) {
    //基础包
    let data = {
        AnalysisFile: AnalysisFile,
    }
    return data;
});